import { Injectable } from '@angular/core';
import { BaseApi } from './_base-api';
import { BannerCreate, BannerDetail, BannerEntity, BannerUpdate } from '@repo/types';

@Injectable({
    providedIn: 'root',
})
export class BannerApiService extends BaseApi<BannerEntity, BannerCreate, BannerUpdate> {
    constructor() {
        super('Banners', {
            get: '/AdminPanel/GetBanners',
            post: '/AdminPanel/AddBanner',
        });
    }
    getBannerDetail(id: number) {
        return http$.get<{ banner: BannerDetail }>(`/AdminPanel/GetBanner?Id=${id}`);
    }
    updateBanner(model: BannerUpdate) {
        return http$.patch<never>('/AdminPanel/EditBanner', model);
    }
    deleteBanner(id: number) {
        return http$.delete<never>('/AdminPanel/DeleteBanner', { body: { id: id } });
    }

}
